import React, { useEffect, useMemo, useState } from 'react';
import logo from '../assets/logo.png';

// 6th anniversary splash shown when the home page opens.
// Plays an "enter" animation, holds, then plays an "exit" animation and unmounts.
const SHOW_MS = 4800;   // time before the exit animation starts
const EXIT_MS = 900;    // must match .anniv-exit animation duration in index.css

const CONFETTI_COLORS = ['#FFD600', '#FFFFFF', '#FFB300', '#FFF176', '#F5C400'];

const AnniversaryIntro = ({ onDone }) => {
  const [visible, setVisible] = useState(true);
  const [leaving, setLeaving] = useState(false);

  const confetti = useMemo(() => Array.from({ length: 70 }, (_, i) => ({
    left: Math.random() * 100,
    delay: Math.random() * 2.5,
    duration: 2.8 + Math.random() * 2.5,
    size: 6 + Math.random() * 8,
    color: CONFETTI_COLORS[i % CONFETTI_COLORS.length],
    round: Math.random() > 0.6,
  })), []);

  useEffect(() => {
    if (!visible) return;
    document.body.style.overflow = 'hidden';
    const t = setTimeout(() => setLeaving(true), SHOW_MS);
    return () => { clearTimeout(t); document.body.style.overflow = ''; };
  }, [visible]);

  useEffect(() => {
    if (!leaving) return;
    const t = setTimeout(() => { setVisible(false); if (onDone) onDone(); }, EXIT_MS);
    return () => clearTimeout(t);
  }, [leaving, onDone]);

  if (!visible) return null;

  return (
    <div
      className={`anniv-overlay ${leaving ? 'anniv-exit' : 'anniv-enter'}`}
      onClick={() => setLeaving(true)}
      role="dialog"
      aria-label="Celebrating 6 years of Dani Job Club"
    >
      {confetti.map((c, i) => (
        <span
          key={i}
          className="anniv-confetti"
          style={{
            left: `${c.left}%`,
            width: c.size,
            height: c.round ? c.size : c.size * 0.45,
            background: c.color,
            borderRadius: c.round ? '50%' : '2px',
            animationDelay: `${c.delay}s`,
            animationDuration: `${c.duration}s`,
          }}
        />
      ))}

      <div className="anniv-rays" />

      <div className="anniv-content">
        <img src={logo} alt="Dani Job Club" className="anniv-logo" />
        <div className="anniv-celebrating">Celebrating</div>
        <div className="anniv-number-wrap">
          <span className="anniv-number">6</span>
          <span className="anniv-th">th</span>
        </div>
        <div className="anniv-years">YEAR</div>
        <div className="anniv-divider" />
        <div className="anniv-tagline">Connecting Talent with Opportunity</div>
        <div className="anniv-thanks">Thank you for being part of our journey!</div>
      </div>

      <button
        type="button"
        className="anniv-skip"
        onClick={e => { e.stopPropagation(); setLeaving(true); }}
      >
        Skip ✕
      </button>
    </div>
  );
};

export default AnniversaryIntro;
